import setProjectArchiveStatus from '$src/api/endpoints/projects/setProjectArchiveStatus'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './ArchiveOrUnarchiveProjectModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import DateInput from '$src/common/DateInput'
import DropZone from 'react-dropzone'
import {getSnapshot} from 'mobx-state-tree'
import moment from 'moment'

interface Props {
  onRequestClose: Function
  mode: 'ArchiveProjectModal' | 'UnarchiveProjectModal'
  projectId: number
  onUpdateNeeded: Function
}

@observer
export default class ArchiveOrUnarchiveProjectModal extends Component<Props, {error?: string; file?: any, submitting: boolean}> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, file: undefined, submitting: false}
  }

  onSubmit = () => {
    this.setState({error: undefined, submitting: true})

    this.callEndpoint(setProjectArchiveStatus, {
      id: this.props.projectId,
      archived: this.props.mode === 'ArchiveProjectModal',
    }).then(
      () => {
        this.setState({submitting: false})
        this.props.onUpdateNeeded()
        this.props.onRequestClose()
      },
      (error: any) => {
        console.log('err', error);

        this.setState(s => ({...s, error: error.message || 'Unauthorized', submitting: false}))
      },
    )
  }

  render() {
    const {props} = this
    const classes = resolveCss(css)
    const projectData = getSnapshot(
      // @ts-ignore
      this.store.projects.baseProjectsById.get(props.projectId),
    )

    return (
      <GenericModal onHide={props.onRequestClose} css={{box: {container: css.box}}}>
        <div className={css.bottom}>
          <p className={css.warningMessage}>Are you sure?</p>
          {this.state.error && <div className={css.error}>Error occured: {this.state.error}</div>}
          <GenericButton variant="pale" type="submit" onClick={props.onRequestClose}>
            Never mind
          </GenericButton>
          <GenericButton variant="bold" type="submit" onClick={this.onSubmit}  disabled={this.state.submitting}>
            {(props.mode === 'ArchiveProjectModal' ? 'Archive' : 'Unarchive') + ' ' + projectData.name}
          </GenericButton>
        </div>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/ArchiveOrUnarchiveProjectModal.tsx